var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BSkeletonTable',{attrs:{"rows":_vm.rows,"columns":_vm.columns,"hide-header":!_vm.showHeader,"table-props":_vm.props}})}
var staticRenderFns = []

export { render, staticRenderFns }